module.exports = __webpack_public_path__ + "Roboto-Medium.574fd0b50367f886d359.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Medium.woff2
// module id = ../../../../../src/font/roboto/Roboto-Medium.woff2
// module chunks = 1